<template>
  <v-container>
    <v-card
      class="px-2"
      flat
    >
      <v-form>
        <v-card flat>
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="codigo"
                label="Código"
                outlined
                dense
              >
                <v-btn
                  class="btn-outer-right pa-0"
                  slot="append"
                  color="success"
                  tile
                  @click.prevent="loadDialog"
                >
                  <v-icon
                    class="mx-0"
                    color="white"
                  >
                    mdi-magnify
                  </v-icon>
                </v-btn>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="codigo"
            >
              <v-checkbox
                v-model="link.inativar"
                label="Inativar link ?"
                color="success"
              ></v-checkbox>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-checkbox
                v-model="link.link_externo"
                label="Url interna?"
                color="success"
                hide-details
                @click="abilitaTarget()"
              ></v-checkbox>
            </v-col>
          </v-row>
          <form-links
            :link="link"
            :locais="locais"
            :link_externo="link_externo"
            :codigo="codigo"
          />
          <v-card>
            <v-tabs
              v-model="tabs"
              height="45"
            >
              <v-tab>
                <v-icon class="mr-2">
                  mdi-note-text
                </v-icon>
                Texto
              </v-tab>
              <v-tab @click="loadMidias">
                <v-icon class="mr-2">
                  mdi-camera
                </v-icon>
                Mídias
              </v-tab>
              <v-tab @click="loadDocs">
                <v-icon class="mr-2">
                  mdi-paperclip
                </v-icon>
                Arquivos
              </v-tab>
            </v-tabs>
            <v-divider></v-divider>
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card class="pa-2">
                        <VueEditor
                          v-model="link.html"
                          placeholder="Conteúdo do banner..."
                        />
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card>
                        <v-card-title>
                          Imagens ou videos
                        </v-card-title>
                        <v-data-table
                          :headers="headersFoto"
                          :items="fotos"
                          :search="search"
                        >
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              medium
                              color="primary"
                              class="mr-2"
                              @click="loadFoto(item)"
                            >
                              mdi-square-edit-outline
                            </v-icon>
                            <v-icon
                              medium
                              color="error"
                              class="mr-2"
                              @click="loadFoto(item, 'remove')"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-btn
                              color="success"
                              class="ml-4 mb-2"
                              v-if="codigo"
                              @click="loadAddFoto"
                            >
                              <v-icon left>
                                mdi-camera
                              </v-icon>
                              Adicionar mídia
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card>
                        <v-card-title>
                          Documentos anexos
                        </v-card-title>
                        <v-data-table
                          :headers="headersDoc"
                          :items="docs"
                          :search="search"
                        >
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              medium
                              color="primary"
                              class="mr-2"
                              @click="loadDoc(item)"
                            >
                              mdi-square-edit-outline
                            </v-icon>
                            <v-icon
                              medium
                              color="error"
                              class="mr-2"
                              @click="loadDoc(item, 'remove')"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-btn
                              color="success"
                              class="ml-4 mb-2"
                              v-if="codigo"
                              @click="loadAddDoc"
                            >
                              <v-icon left>
                                mdi-paperclip
                              </v-icon>
                              Adicionar anexo
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
          <v-card-actions class="justify-start mt-4">
            <v-btn
              color="success"
              class="mr-4"
              v-if="!codigo"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="success"
              class="mr-4"
              v-if="codigo"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Atualizar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="codigo"
              @click="remove"
            >
              <v-icon left>
                mdi-trash-can-outline
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar boletins
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="links"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click="loadLink(item)"
                    >
                      mdi-arrow-down-bold-box
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="addFoto"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar mídia
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Fotos ou vídeos do covid19"
                  />
                  <v-form>
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="foto.usuario"
                    />
                    <input
                      id="foto-id"
                      type="hidden"
                      v-model="foto.id"
                    />
                    <input
                      id="foto-uuid"
                      type="hidden"
                      v-model="foto.uuid"
                    />
                    <input
                      id="uid_boletim"
                      type="hidden"
                      v-model="foto.uuid_boletim"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="codigo"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="codigo"
                      >
                        <v-checkbox
                          v-model="foto.inativar"
                          label="Inativar Foto?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="codigo"
                      >
                        <v-checkbox
                          v-model="foto.site_img"
                          label="Substituir texto por imagem ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="dtpub"
                              v-model="data_publicacao"
                              label="Data de publicação.:"
                              dense
                              outlined
                              @blur="mudaDataMidia"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date1"
                            @input="dateF"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <input
                        accept="image/png, image/jpeg, image/bmp"
                        prepend-icon="mdi-camera"
                        label="Arquivo de imagem"
                        v-if="uploadReady"
                        type="file"
                        ref="file"
                        @change="selectFile()"
                      >
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="codigo"
                    type="submit"
                    @click.prevent="fileUpload()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="codigo"
                    @click="clearUpload"
                  >
                    Remover
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addDoc"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar arquivos anexo
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Documento em anexo a página"
                  />
                  <v-form>
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="doc.usuario"
                    />
                    <input
                      id="doc-id"
                      type="hidden"
                      v-model="doc.id"
                    />
                    <input
                      id="doc-uuid"
                      type="hidden"
                      v-model="doc.uuid"
                    />
                    <input
                      id="uid_boletim"
                      type="hidden"
                      v-model="doc.uuid_boletim"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="codigo"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="codigo"
                      >
                        <v-checkbox
                          v-model="doc.inativar"
                          label="Inativar arquivo?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="codigo"
                      >
                        <v-checkbox
                          v-model="doc.site_img"
                          label="Mostrar no site ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="dtpub"
                              v-model="data_publicacao"
                              label="Data de publicação.:"
                              dense
                              outlined
                              @blur="mudaDataMidia"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date1"
                            @input="dateF"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <input
                        accept="application/vnd.ms-excel, application/vnd.ms-word, application/pdf"
                        prepend-icon="mdi-paperclip"
                        label="Documento"
                        v-if="uploadReady"
                        type="file"
                        ref="file"
                        @change="selectFile()"
                      >
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="codigo"
                    type="submit"
                    @click.prevent="docUpload()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="codigo"
                    @click="clearUpload"
                  >
                    Remover
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { VueEditor } from 'vue2-editor'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
import FormLinks from '../forms/formLinks.vue'
export default {
  name: 'Links',
  components: { PageTitle, VueEditor, FormLinks },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    dta: '##/##/####',
    dtpub: '##/##/####',
    tabs: null,
    codigo: '',
    link_externo: false,
    dialog: false,
    addFoto: false,
    addDoc: false,
    uploadReady: true,
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    data_criacao: '',
    data_publicacao: '',
    menu: false,
    menu1: false,
    time: '',
    file: '',
    tabela: 'informativo',
    search: '',
    mode: 'save',
    link: {},
    links: [],
    locais: [],
    foto: {},
    fotos: [],
    doc: {},
    docs: [],
    length: '',
    targets: [
      { value: '_top', text: '_top' },
      { value: '_self', text: '_self' },
      { value: '_blank', text: '_blank' }
    ],
    icons: [
      { value: 'pdf', text: 'PDF' },
      { value: 'word', text: 'WORD' },
      { value: 'exel', text: 'EXEL' }
    ],
    posicao: [
      { value: 'L', text: 'Lado direito' },
      { value: 'R', text: 'Lado esquerdo' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Data', value: 'data_criacao' },
      { text: 'Local da página', value: 'local_page' },
      { text: 'Url interna', value: 'link_externo', sortable: false },
      { text: 'Target', value: 'target_url', sortable: false },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersFoto: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url_foto' },
      { text: 'Tam Arq.', value: 'size_foto' },
      { text: 'Data', value: 'data_publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersDoc: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url_doc' },
      { text: 'Tam Arq.', value: 'size_doc' },
      { text: 'Data', value: 'data_publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    dateF () {
      this.data_publicacao = moment(this.date1).format('DD/MM/YYYY')
      this.menu = false
    },

    mudaDataMidia () {
      const [dia, mes, ano] = this.data_publicacao.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      this.link.data_criacao = this.date
      const method = this.link.id ? 'put' : 'post'
      const id = this.link.id ? `/${this.link.id}` : ''
      axios[method](`${baseApiUrl}/links-de-informativos${id}`, this.link)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/midia-link-informativo`
      formData.append('uuid', this.foto.uuid)
      formData.append('uuid_informativo', this.link.uuid)
      formData.append('uid_informativo', this.link.id)
      formData.append('data_publicacao', this.date1)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.link.id)
      formData.append('usuario', this.foto.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
          this.loadFotos()
        })
        .catch(showError)
    },
    async docUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/doc-link-informativo`
      formData.append('uuid', this.doc.uuid)
      formData.append('uuid_informativo', this.link.uuid)
      formData.append('uid_informativo', this.link.id)
      formData.append('data_publicacao', this.date1)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.link.id)
      formData.append('usuario', this.doc.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
          this.loadDocs()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.foto = {}
      this.doc = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadLinks () {
      const url = `${baseApiUrl}/links-de-informativos`
      axios.get(url).then(res => {
        this.links = res.data
      })
    },
    loadFotos () {
      const idM = this.link.uuid
      const url = `${baseApiUrl}/midias-de-links-de-informativos/${idM}`
      axios.get(url).then(res => {
        this.fotos = res.data
      })
    },
    loadAnexos () {
      const idC = this.link.uuid
      const url = `${baseApiUrl}/docs-de-links-de-informativos/${idC}`
      axios.get(url).then(res => {
        this.docs = res.data
      })
    },
    loadLink (link) {
      const idC = link.uuid
      const url = `${baseApiUrl}/links-de-informativos-update/${idC}`
      axios.get(url).then(res => {
        this.link = res.data
        this.codigo = link.id
        this.link_externo = this.link.link_externo
        this.dialog = false
      })
    },
    abilitaTarget () {
      this.link_externo = this.link.link_externo
    },
    loadFoto () {

    },
    loadMidias () {
      this.loadFotos()
    },
    loadDocs () {
      this.loadAnexos()
    },
    loadLocais () {
      const url = `${baseApiUrl}/local-da-pagina`
      axios.get(url).then(res => {
        this.locais = res.data.map(locais => {
          return {
            value: locais.id,
            text: `${locais.local_page}`
          }
        })
      })
    },
    reset () {
      this.mode = 'save'
      this.link = {}
      this.codigo = ''
      this.link_externo = false
      this.link.uuid = uuid.v1()
      this.link.usuario = this.user.id
      this.loadDatas()
    },
    loadDialog () {
      this.dialog = true
      this.loadLinks()
    },
    loadAddFoto () {
      this.foto.uuid = uuid.v1()
      this.foto.usuario = this.user.id
      this.dateF()
      this.addFoto = true
    },
    loadAddDoc () {
      this.doc.uuid = uuid.v1()
      this.doc.usuario = this.user.id
      this.dateF()
      this.addDoc = true
    },
    loadUser () {
      this.link.uuid = uuid.v1()
      this.link.usuario = this.user.id
      this.loadLocais()
    },
    loadDatas () {
      const dataAgora = new Date().toISOString().substr(0, 10)
      this.data_criacao = moment(dataAgora).format('DD/MM/YYYY')
      this.date = dataAgora
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>
<style scoped>
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
</style>
